import * as clientProductsStatic from '../../../../features/client-products/constants/client-products.static';

export const CLIENT_PRODUCTS_DATA =
    clientProductsStatic.CLIENT_PRODUCTS_LISTING_ROUTE_DATA;
export const CLIENT_PRODUCTS_TABLE_HEADERS =
    clientProductsStatic.CLIENT_PRODUCTS_LISTING_HEADERS;
